import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { BreAppModule } from './app/bre-app.module'
import { environment } from './environments/environment'
import { Amplify } from 'aws-amplify'
import awsExports from './aws-exports'

Amplify.configure(awsExports)

if (environment.production) {
  enableProdMode()
}

platformBrowserDynamic()
  .bootstrapModule(BreAppModule)
  .catch(err => console.error(err))
